import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { s as u } from "../../../constants-C9JADvZj.mjs";
import { Dropdown as p } from "../../Dropdown/Dropdown.js";
import { Input as n } from "../../Input/Input.js";
import "../../Input/BaseInput.js";
import d from "../../TextArea/TextArea.js";
import { Wrapper as b, InputContainer as r } from "./styled.js";
const T = ({
  fieldName: l,
  fullAddressProps: o,
  suburbProps: a,
  postCodeProps: m,
  stateProps: t
}) => {
  var i;
  return /* @__PURE__ */ s(b, { children: [
    /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e(
      d,
      {
        name: `${l}.fullDetails.fullAddress`,
        mode: "Input",
        label: "Street address",
        hint: "Please include unit number if needed",
        ...o
      }
    ) }),
    /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e(n, { name: `${l}.fullDetails.suburb`, label: "Suburb/Town", ...a }) }),
    /* @__PURE__ */ e(r, { children: ((i = t == null ? void 0 : t.options) == null ? void 0 : i.length) === 0 ? /* @__PURE__ */ e(n, { name: `${l}.fullDetails.state`, label: "State/Territory", ...t }) : /* @__PURE__ */ e(
      p,
      {
        name: `${l}.fullDetails.state`,
        label: "State/Territory",
        options: u,
        placeholder: "Select",
        ...t
      }
    ) }),
    /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e(
      n,
      {
        type: "tel",
        name: `${l}.fullDetails.postCode`,
        label: "Postcode",
        maskingOptions: { mask: "9999" },
        ...m
      }
    ) })
  ] });
};
export {
  T as default
};
